/* eslint-disable import/no-mutable-exports,
    @typescript-eslint/no-unsafe-assignment,
    @typescript-eslint/no-unsafe-call,
    @typescript-eslint/no-explicit-any,
    @typescript-eslint/no-unsafe-return,
    @typescript-eslint/no-unsafe-member-access,
    consistent-return,
    no-underscore-dangle, no-plusplus */

export const getUrlQuery = (variable: any) => {
  const data = window as any;
  const query = data.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
};

export default getUrlQuery;
